module.exports = __webpack_public_path__ + "img/ntk_nav_left_g.7d489eb0.svg";